import { Link, type LinkProps } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

/**
 * A link only for callers who may open its target; for everyone else the same
 * content as plain text, so a screen never sends the user to a full-page 403
 * (audit 2026-09-23 §C). `permission` = the function(s) the target route needs.
 */
export function PermLink({
  permission,
  children,
  className,
  style,
  title,
  ...rest
}: LinkProps & { permission: string | string[] }) {
  const { hasPermission } = useAuth();
  const keys = Array.isArray(permission) ? permission : [permission];
  if (!keys.every((k) => hasPermission(k))) {
    return <span className={className} style={style} title={title}>{children}</span>;
  }
  return <Link className={className} style={style} title={title} {...rest}>{children}</Link>;
}
